
const tips = document.querySelectorAll('.tip');
if (tips.length) {
    let {createPopper} = await import("@popperjs/core");
    tips.forEach((tip) => {
        if (tip.classList.contains('disable-popper')) {
            return;
        }
        let control = tip.querySelector('.tip__control');
        let content = tip.querySelector('.tip__content');
    
        tip.addEventListener('mouseover', function () {
            createPopper(control, content, {
                placement: 'top',
                modifiers: {
                    name: 'offset',
                    options: {
                        offset: [20, 20]
                    }
                }
            });
        });
    });
}

